import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchTestimonial } from '../services';

// Thunk asíncrono para obtener los datos de testimonial desde la API
export const fetchTestimonialData = createAsyncThunk(
    'testimonial/fetchTestimonialData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchTestimonial();
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const testimonialSlice = createSlice({
    name: 'testimonial',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        // Puedes agregar más acciones sincronas si es necesario
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchTestimonialData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTestimonialData.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchTestimonialData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default testimonialSlice.reducer;
